<template>
  <div>brands</div>
</template>
<script>
export default {
  name: 'Brands',
}
</script>
